module.exports = __webpack_public_path__ + "static/media/legato_logo.c597fbde.png";